module.exports = __webpack_public_path__ + "img/05.52279dbf.jpg";